<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelims-head" lang="en-GB">Dedicated to…</h1>
<p class="Prelims-main" lang="en-GB">Barnes as always, <br/>and for the hardworking and dedicated <br/>National Health Service.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398432048_EPUB4.vue?cabd4352